<template>
    <div id="agents-index-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Agents</h1>

                <div class="table-header" style="margin-bottom:20px;">
                    <div class="table-header__tabs"></div>
                    <div class="table-header__controls">
                        <router-link to="/agents/create" class="table-header__controls__btn">New Agent</router-link>
                    </div>
                </div>

                <DataTable class="agents-data-table"
                           :dataUrl="dataUrl"
                           :displayId="true"
                           :key="tableRefreshKey"
                           :dataFormatter="formatData"
                           @actionTriggered="actionTriggered">

                    <template v-slot:empty>
                        No records found
                    </template>
                </DataTable>
            </section>
        </div>
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'
const endpoint = process.env.VUE_APP_API_BASE + '/agents'
import axios from 'axios'

export default {
    name: 'AgentsIndex',
    components: {
        DataTable
    },
    data: function() {
        return {
            dataUrl: endpoint,
            tableRefreshKey: null
        }
    },
    methods: {
        formatData(data) {
            const newData = []
            for (let obj of data) {
                const newObj = {}
                for (let key in obj) {
                    const ignore = ['__v', 'managedCountries']
                    if (ignore.includes(key)) {
                        continue
                    }
                    else if (key.includes('At')) {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'date'
                        }
                    }
                    else {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'text'
                        }
                    }
                }

                if (Array.isArray(obj.managedCountries) && obj.managedCountries.length > 0) {
                    newObj['managedCountries'] = {
                        'label': 'managedCountries',
                        'value': obj.managedCountries.map(c => c.name).join(', '),
                        'display_type': 'text'
                    }
                }

                const actions = {
                    'edit': `<i class="edit-action" title="Edit">Edit</i>`,
                    'delete': `<i class="delete-action" title="Delete">Delete</i>`
                }
                newObj['actions'] = {
                    'label': '',
                    'value': actions,
                    'display_type': 'actions'
                }

                newData.push(newObj)
            }
            return newData
        },
        actionTriggered(actionKey, identifier) {
            if (!identifier) {
                alert('Error occurred #89-2')
            }
            else if (actionKey == 'edit') {
                this.$router.push('/agents/' + identifier)
            }
            else if (actionKey == 'delete') {
                if (confirm('Are you sure you want to delete this agent?')) {
                    axios.delete(endpoint + '/' + identifier)
                        .then(response => {
                            if (response.data.success === true) {
                                this.tableRefreshKey = Date.now()
                            }
                            else {
                                alert('Error occurred')
                                console.log(response.data.data)
                            }
                        })
                        .catch(error => {
                            alert('Error occurred while deleting')
                            console.log(error)
                        })
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
